
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/[step]",
      function () {
        return require("private-next-pages/register/[step].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/[step]"])
      });
    }
  